
import { motion } from "framer-motion";
import { useLocation } from "wouter";
import React from "react";
import { RenderIcon } from "../ui/app-icon";


interface AppIconProps {
    hideName?:boolean;
    app: {
      id: string;
      name: string;
      icon: string;
      color: string;
      description: string;
    };
    index: number;
  }
  
  export const AppIcon: React.FC<AppIconProps> = ({ app, index, hideName }) => {
    const [, setLocation] = useLocation();
    
    // Dynamically get the icon from Lucide

    const handleClick = (e: React.MouseEvent) => {
      e.preventDefault();
      e.stopPropagation();
      setLocation(`/app/${app.id}`);
    };
    
    return (
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.3, delay: index * 0.05 }}
        className="flex flex-col items-center relative z-30"
      >
        <button 
          onClick={handleClick}
          className="flex flex-col items-center focus:outline-none w-full"
        >
          <div 
            className="w-16 h-16 rounded-2xl flex items-center justify-center mb-2 shadow-lg hover:scale-105 transition-transform"
            style={{ backgroundColor: app.color }}
          >
            <RenderIcon icon={app.icon} />
          </div>
          {!hideName && (
            <span className="text-sm text-white font-medium text-center">
              {app.name}
            </span>
          )}
        </button>
      </motion.div>
    );
  };